export function MetaPage() {
  return (
    <section className="simple-page">
      <h1>Meta</h1>
      <p>placeholder content - there will be changelog and site related information posted here eventually.</p>
    </section>
  );
}
